import { Component, Input } from '@angular/core';
import { ConnectionAuthUrl } from '../../../interfaces/connection-auth-url';
@Component({
  selector: 'app-instagram-auth',
  templateUrl: './instagram-auth.component.html',
  styleUrls: ['./instagram-auth.component.scss'],
})
export class InstagramAuthComponent {
  @Input() public connection: ConnectionAuthUrl;
  public modal: HTMLIonModalElement;

  async authenticate(): Promise<void> {
    this.connection.authenticate();
  }
}
